import { FC } from "react";
import { IIdmStaffMember } from "../../../../entities/idm";
import { MyButton } from "../../../../shared/ui/button";
import { MyInput } from "../../../../shared/ui/input";
import { LoaderSpinner } from "../../../../shared/ui/spinner";
import lupaImg from "../../../../features/searchItems/lib/assets/lupa.png";
import idmClasses from "../../../idm/ui/idm/idmWidget.module.scss";
import classes from "../staff/staffWidget.module.scss";
import { TStaffPermissions } from "../../model/getStaffPermissions";
import { TStaffAccessManagement } from "../../model/useStaffAccessManagement";

type TAccessPermissions = Pick<TStaffPermissions,
    'canAssignUserRoles'
    | 'canRemoveUserRoles'
    | 'canListUserFeatures'
    | 'canGrantUserFeatures'
    | 'canListAvailableFeatures'
    | 'canRevokeUserFeatures'
>

interface IStaffAccessContentProps {
    staffMember: IIdmStaffMember;
    permissions: TAccessPermissions;
    access: TStaffAccessManagement;
    showRolesWidget: boolean;
    canAssignIdmRoles: boolean;
    canListRoles: boolean;
}

export const StaffAccessContent: FC<IStaffAccessContentProps> = ({
    staffMember,
    permissions,
    access,
    showRolesWidget,
    canAssignIdmRoles,
    canListRoles,
}) => {
    const {
        canAssignUserRoles,
        canRemoveUserRoles,
        canListUserFeatures,
        canGrantUserFeatures,
        canListAvailableFeatures,
        canRevokeUserFeatures,
    } = permissions
    const {
        isFeatureListOpen,
        setIsFeatureListOpen,
        featureListSearch,
        setFeatureListSearch,
        isUserFeaturesLoading,
        filteredEffectiveFeatures,
        onRemoveRole,
        onRevokeFeature,
        setRolesModalOpen,
        setFeaturesModalOpen,
    } = access

    return (
        <>
            {showRolesWidget && (
                <section className={idmClasses.panel}>
                    <section className={idmClasses.sectionHeader}>
                        <span>Роли IDM</span>
                        {canAssignIdmRoles && canAssignUserRoles && canListRoles && (
                            <MyButton onClick={() => setRolesModalOpen(true)}>Назначить</MyButton>
                        )}
                    </section>
                    <section className={idmClasses.badges}>
                        {staffMember.roles.map(role => (
                            <section key={role.role_id} className={idmClasses.badge}>
                                <span>{role.role_name}</span>
                                {canRemoveUserRoles && <button onClick={() => onRemoveRole(role.role_id)}>x</button>}
                            </section>
                        ))}
                    </section>
                </section>
            )}

            {canListUserFeatures && (
                <section className={idmClasses.panel}>
                    <section className={idmClasses.sectionHeader}>
                        <section className={idmClasses.sectionHeaderMain}>
                            <span>Доступные фичи</span>
                            <button
                                className={idmClasses.expandButton}
                                onClick={() => setIsFeatureListOpen(!isFeatureListOpen)}
                                aria-label={isFeatureListOpen ? 'Свернуть список фич' : 'Развернуть список фич'}
                            >
                                <svg className={idmClasses.expandIcon + (isFeatureListOpen ? ` ${idmClasses.expandIconOpen}` : '')} width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M26 12L16 22L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                            </button>
                        </section>
                        {canGrantUserFeatures && canListAvailableFeatures && <MyButton onClick={() => setFeaturesModalOpen(true)}>Выдать</MyButton>}
                    </section>
                    <section className={idmClasses.featureList + (isFeatureListOpen ? ` ${idmClasses.featureListOpen}` : '')}>
                        {isFeatureListOpen && isUserFeaturesLoading
                            ? <section className={classes.loaderWrap}><LoaderSpinner/></section>
                            : isFeatureListOpen && (
                                <>
                                    <section className={idmClasses.modalSearch}>
                                        <MyInput
                                            placeholder="Поиск по выданным фичам"
                                            value={featureListSearch}
                                            setValue={setFeatureListSearch}
                                            iconSrc={lupaImg}
                                        />
                                    </section>
                                    {filteredEffectiveFeatures.length === 0 && (
                                        <section className={classes.emptyState}>Выданные фичи не найдены</section>
                                    )}
                                    {filteredEffectiveFeatures.map((feature, index) => (
                                        <section key={`${feature.feature_id || feature.feature_key || 'feature'}-${index}`} className={idmClasses.featureItem}>
                                            <section>
                                                <section className={idmClasses.featureTitle}>{feature.feature_name}</section>
                                                <section className={idmClasses.featureMeta}>{feature.category} · {feature.feature_key}</section>
                                            </section>
                                            <section className={idmClasses.featureActions}>
                                                {canRevokeUserFeatures && (
                                                    <button className={idmClasses.linkButton} onClick={() => onRevokeFeature(feature.feature_id)}>
                                                        Отозвать
                                                    </button>
                                                )}
                                            </section>
                                        </section>
                                    ))}
                                </>
                            )
                        }
                    </section>
                </section>
            )}
        </>
    )
}
